import Elibrary from "@sabyr-dev/mist_elibrary";
import { AcademyApp, Config } from "./mist/app";
import { AcademyDataSourceFactory } from "./mist/model/datasource";
import { AcademyFrontendFactory } from './mist/view/frontend';
import {
	AcademyInitOverviewController, AcademyNavigationController,
	AcademyTestController, EmailController, InitController,
	ReviewInitController, TestInitController
} from "./mist/controllers";
import { AcademyUserData } from "./mist/lib/userdata";

export default class Academy extends Elibrary {
	static datasource: AcademyDataSourceFactory = new AcademyDataSourceFactory();
	static frontend: AcademyFrontendFactory = new AcademyFrontendFactory();

	static constructOverviewApp(config: Config): AcademyApp {
		return AcademyApp.constructOverview(
			Academy.datasource, Academy.frontend, config,
			undefined, { init: new AcademyInitOverviewController() }, undefined,
			{ userdata: new AcademyUserData() }
		) as AcademyApp;
	}

	static constructTestApp(config: Config): AcademyApp {
		return AcademyApp.constructTest(
			Academy.datasource, Academy.frontend, config,
			undefined,
			{ navigation: new AcademyNavigationController(), test: new AcademyTestController() },
			[new InitController(), new TestInitController(), new EmailController(false)],
			{ userdata: new AcademyUserData() }
		) as AcademyApp;
	}

	static constructReviewApp(config: Config): AcademyApp {
		return AcademyApp.constructReview(
			Academy.datasource, Academy.frontend, config,
			undefined,
			{ navigation: new AcademyNavigationController() },
			[ new InitController(), new ReviewInitController(), new EmailController(true)],
			{ userdata: new AcademyUserData() }
		) as AcademyApp;
	}
}
